import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchOwnClinicContact } from '@/api/clinic/clinicApi';
import type { ClinicContact } from '@/api/clinic/clinicApi.types';
import { OWN_CLINIC_CONTACT_QUERY_KEY } from '@/constants/queryKeys';

export function useOwnClinicContactQuery(): UseQueryResult<ClinicContact, Error> {
  return useQuery({ queryKey: OWN_CLINIC_CONTACT_QUERY_KEY, queryFn: fetchOwnClinicContact });
}
